export default __webpack_public_path__ + "static/media/DoubleToroClosed.e7e14e46.jpg";